import Vue from 'vue'
import VueRouter from 'vue-router'
import { db } from '../firebaseDb';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/Home')
  },
  {
    path: '/create',
    name: 'create',
    component: () => import('../components/TicketCreate'),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/config',
    name: 'config',
    component: () => import('../components/Config'),
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../components/TicketList'),
    meta: {
      authRequired: true,
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
      if (db.app.auth().currentUser) {
          next();
      } else {
          const cookieAuthToken = Vue.$cookies.get('ods-auth-token');
          if (cookieAuthToken) {
            db.app.auth().signInWithCustomToken(cookieAuthToken)
            .then(function() {
              next();
            })
            .catch(function() {
              alert('You must be logged in to see this page');
              next({
                  path: '/',
              });
            })
          } else {
            alert('You must be logged in to see this page');
            next({
                path: '/',
            });
          }       
    }
  } else {
    next();
  }
});

export default router